// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-2adfb357] .dx-radiogroup-horizontal .dx-collection {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\n}\n.grid-border[data-v-2adfb357] {\r\n    border: 1px solid #e5e7eb;\r\n    width: auto;\n}\n.gridContainer[data-v-2adfb357] {\r\n    width: 100%;\r\n    overflow-x: auto;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
